export default "__VITE_ASSET__3c46617b__"